var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideocam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_8284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_8284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.54773 19.5C4.04273 19.5 3.61523 19.325 3.26523 18.975C2.91523 18.625 2.74023 18.1974 2.74023 17.6923V6.30775C2.74023 5.80258 2.91523 5.375 3.26523 5.025C3.61523 4.675 4.04273 4.5 4.54773 4.5H15.9325C16.4375 4.5 16.865 4.675 17.215 5.025C17.565 5.375 17.74 5.80258 17.74 6.30775V10.8848L20.4862 8.1385C20.6337 7.991 20.7994 7.95417 20.9832 8.028C21.1672 8.10167 21.2592 8.24233 21.2592 8.45V15.55C21.2592 15.7577 21.1672 15.8983 20.9832 15.972C20.7994 16.0458 20.6337 16.009 20.4862 15.8615L17.74 13.1152V17.6923C17.74 18.1974 17.565 18.625 17.215 18.975C16.865 19.325 16.4375 19.5 15.9325 19.5H4.54773Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocam);
export default __webpack_public_path__ + "static/media/videocam.b7b585f5fb7ca8c6c94900f561714182.svg";
export { ForwardRef as ReactComponent };